import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CancelHoldButton from '@bibliocommons/cancel-hold-button';
import RequestItemButton from '../components/shared/RequestItemButton';
import { CheckedOutReadingLinks } from '../components/shared/ItemTransactions';
import { MATERIAL_TYPE_DIGITAL } from '../constants/BibConstants';
import * as CheckoutActions from '../actions/CheckoutActions';
import * as HoldActions from '../actions/HoldActions';
import { currentAccountSelector } from '../selectors/AuthSelector';
import { getActiveHoldsByMetadataId } from '../selectors/HoldsSelector';
import { getCheckoutsByMetadataId } from '../selectors/CheckoutSelector';

import { itemTransactionConstants, itemTransactionStatus } from '@bibliocommons/utils-item';


export function ItemTransactionButtonContainer(props) {
  const { holdable, hold, isLoading, id, holdActions, checkoutActions, availableForCheckout, checkout, materialType,
    materialPolicy, accountId, format, title, authors, hasItemLevelHoldableItems, titleNotOwned, workflowId, messagingId } = props;

  let element;
  const isDigitalHoldReady = hold && hold.get('status') === 'READY_FOR_PICKUP' && materialType === MATERIAL_TYPE_DIGITAL;

  if (!holdable) {
    return null;
  }

  const status = itemTransactionStatus(hold, materialType, hasItemLevelHoldableItems, checkout);

  switch (status) {
    case itemTransactionConstants.CANCEL_HOLD_BUTTON:
      element = <CancelHoldButton metadataId={id} cancelHold={() => holdActions.startCancelHold(workflowId || id, id, messagingId)} isLoading={isLoading} />;
      break;
    case itemTransactionConstants.DIGITAL_READING_LINKS:
      element = (
        <CheckedOutReadingLinks
          checkInEnabled={checkout.get('checkInEnabled')}
          downloadable={checkout.get('downloadable')}
          format={checkout.get('format')}
          downloadUrl={checkout.get('downloadUrl')}
          thirdPartyReaderUrl={checkout.get('thirdPartyReaderUrl')}
          policy={materialPolicy}
          metadataId={id}
          messagingId={messagingId}
          checkoutId={checkout.get('checkoutId')}
          accountId={accountId}
          checkIn={checkoutActions.digitalCheckIn}
          startDigitalMissingFormatSelection={() => checkoutActions.startDigitalMissingFormatSelection(workflowId || id, id, messagingId)} />
      );
      break;
    case itemTransactionConstants.REQUEST_ITEM_BUTTON:
    default:
      element = (
        <RequestItemButton
          metadataId={id}
          handleHoldClick={() => holdActions.startPlaceHold(workflowId || id, id, messagingId)}
          isLoading={isLoading}
          availableForCheckout={availableForCheckout || isDigitalHoldReady}
          materialType={materialType}
          handleCheckoutClick={() => checkoutActions.startDigitalCheckout(workflowId || id, id, messagingId)}
          format={format}
          title={title}
          treatAsItemLevelHold={hasItemLevelHoldableItems && materialPolicy.get('itemLevelHoldsPredetermined')}
          authors={authors}
          serviceAvailable={materialPolicy.get('healthy')}
          titleNotOwned={titleNotOwned} />
      );
  }

  return (
    <div className="item-transaction-button-wrap">
      {element}
    </div>
  );
}

ItemTransactionButtonContainer.propTypes = {
  hold: ImmutablePropTypes.mapContains({
    id: PropTypes.string,
    status: PropTypes.string
  }),
  workflowId: PropTypes.string,
  messagingId: PropTypes.string,
  holdable: PropTypes.bool,
  isLoading: PropTypes.bool,
  holdActions: PropTypes.objectOf(PropTypes.func).isRequired,
  checkoutActions: PropTypes.objectOf(PropTypes.func).isRequired,
  materialPolicy: ImmutablePropTypes.map,
  materialType: PropTypes.string,
  checkout: ImmutablePropTypes.mapContains({
    id: PropTypes.string
  }),
  accountId: PropTypes.number,
  availableForCheckout: PropTypes.bool,
  id: PropTypes.string.isRequired,
  format: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  authors: ImmutablePropTypes.listOf(React.PropTypes.string),
  hasItemLevelHoldableItems: PropTypes.bool,
  titleNotOwned: PropTypes.bool
};

ItemTransactionButtonContainer.displayName = 'ItemTransactionButtonContainer';

const mapStateToProps = (state, ownProps) => {
  const account = currentAccountSelector(state, ownProps);
  const briefInfo = state.getIn(['entities', 'bibs', ownProps.id, 'briefInfo']);
  const policy = state.getIn(['entities', 'bibs', ownProps.id, 'policy'], Immutable.Map());
  const holds = getActiveHoldsByMetadataId(state).get(ownProps.id, Immutable.List());
  const availabilityStatus = state.getIn(['entities', 'bibs', ownProps.id, 'availability', 'status']);
  const checkouts = getCheckoutsByMetadataId(state).get(ownProps.id, Immutable.List());

  return {
    accountId: account && account.get('id'),
    hold: holds.size === 1 ? holds.first() : null,
    holdable: state.getIn(['entities', 'bibs', ownProps.id, 'policy', 'holdable'], false),
    isLoading: state.getIn(['ui', 'itemTransactions', ownProps.id, 'isLoading'], false),
    checkout: checkouts.first(),
    availableForCheckout: availabilityStatus === 'AVAILABLE',
    materialType: state.getIn(['entities', 'bibs', ownProps.id, 'policy', 'materialType']),
    materialPolicy: policy.get('materialPolicy', Immutable.Map()),
    format: briefInfo.get('format'),
    title: briefInfo.get('title'),
    authors: briefInfo.get('authors'),
    hasItemLevelHoldableItems: policy.get('itemLevelHoldableItems'),
    titleNotOwned: availabilityStatus === 'RESOURCE_NOT_FOUND'
  };
};

const mapDispatchToProps = dispatch => ({
  holdActions: bindActionCreators(HoldActions, dispatch),
  checkoutActions: bindActionCreators(CheckoutActions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(ItemTransactionButtonContainer);



// WEBPACK FOOTER //
// ./app/containers/ItemTransactionButtonContainer.jsx